import React, { useMemo } from 'react';
import { Dimmer, Loader, Button, Grid } from 'semantic-ui-react';
import RenderSection from '../renderSections';
import { FormData } from '../../types';
import { useNotificationEmails } from '../../hooks/useNotificationEmails';
interface ClaimStepProps {
  estateId?: string;
}

const ClaimStep: React.FC<ClaimStepProps> = ({ estateId }) => {
  const defaultFormData: FormData = useMemo(
    () => ({
      creationResponsible: false,
      client: false,
      estateMain: false,
      estateManager: false,
      tempMail: '',
      additionalRecipient: []
    }),
    []
  );

  const subcategories = useMemo(() => ['newClaim', 'newFollowup', 'claimEdit'], []);

  const titleMap: Record<string, string> = {
    newClaim: 'Novo Sinistro',
    newFollowup: 'Novo Followup'
  };

  const {
    loading,
    formData,
    handleUpdateFormData,
    handleSave,
    isBackofficeTest
  } = useNotificationEmails({ estateId, category: 'claim', subcategories, defaultFormData });

  return (
    <>
      <Dimmer active={loading} page>
        <Loader inline />
      </Dimmer>

      {subcategories.map(subcategory => (
        <RenderSection
          key={subcategory}
          title={titleMap[subcategory]}
          sectionKey={subcategory}
          formData={formData[subcategory]}
          onUpdate={handleUpdateFormData}
        />
      ))}

      <Grid style={{ marginLeft: '65%' }}>
        <Grid.Row columns={2} style={{ gap: '1rem' }}>
          <Button basic size="large" disabled={isBackofficeTest}>
            Cancelar
          </Button>
          <Button color="green" size="large" disabled={isBackofficeTest} onClick={handleSave}>
            Salvar alterações
          </Button>
        </Grid.Row>
      </Grid>
    </>
  );
};

export default ClaimStep;
